import React from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { BlogAskADemoContent } from './BlogAskADemoContent';
import { BlogAskADemoImage } from './BlogAskADemoImage';
import { BlogAskADemoImageBox } from './BlogAskADemoImageBox';
import { BlogAskADemoZoneText } from './BlogAskADemoZoneText';
import { BlogAskADemoZoneButton } from './BlogAskADemoZoneButton';

export const BlogAskADemoComponent = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  return (
    <Component
      className={classNames(
        'BlogAskADemo',
        className,
        'bg-blue-21 rounded-12 flex',
        'relative overflow-hidden',
        'blog-ask-a-demo',
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

export const BlogAskADemo = Object.assign(BlogAskADemoComponent, {
  Content: BlogAskADemoContent,
  Image: BlogAskADemoImage,
  ImageBox: BlogAskADemoImageBox,
  ZoneText: BlogAskADemoZoneText,
  ZoneButton: BlogAskADemoZoneButton,
});
